export default {
  Title: {
    Username : 'Type your username',
    PinPass  : 'Type your personal PIN',
    Terms    : 'Accept Terms and Conditions',
    AdminPass: 'Type administrator password'
  },
  Field: {
    Username: {
      Label: 'Username',
      Hint : 'Email or UID',
      Icon : 'person_pin',
      Error: {
        Empty: 'Insert username',
        Min  : 'Username must be at least 8 characters long'
      }
    },
    AdminPass: {
      Label: 'Administrator password',
      Icon : 'password'
    },
    RememberMe: {
      Label: 'Remember me'
    },
    Result: {
      WrongUsernamePin: 'Wrong username or PIN',
      WrongPin        : 'Wrong PIN Code',
      WrongPassword   : 'Wrong password'
    },
    Terms: {
      Title: 'Terms of Use & Provision of Services',
      Body : `<p>The use of the services of Getfood Pro implies the full and unconditional acceptance of the <span class="gfp-terms-link"><a href="https://terms.getfoodpro.com/" target="_blank" >Terms of Use and Provision of Services</a></span> of Getfood Pro.</p>`
    }
  },
  StaffGroup: {
    11 : 'Super Admin',
    12 : 'GFP Editor',
    13 : 'CRM Editor',
    100: 'Owner',
    101: 'Cashier',
    102: 'Waiter',
    103: 'User',
    104: 'Delivery'
  }
}
